import React from 'react';

/**
 * Logos et visuels de marque : freins UX contre glisser-déposer et « Enregistrer l'image sous… » au clic droit.
 * ⚠️ Pas une barrière cryptographique : onglet Réseau/Cache, screenshot, impression restent toujours possibles.
 */
export default function BrandProtectedImg({
  className = '',
  style,
  onContextMenu,
  onDragStart,
  ...rest
}) {
  return (
    <img
      {...rest}
      draggable={false}
      onContextMenu={(e) => {
        e.preventDefault();
        onContextMenu?.(e);
      }}
      onDragStart={(e) => {
        e.preventDefault();
        onDragStart?.(e);
      }}
      className={[className, 'brand-protected-img'].filter(Boolean).join(' ')}
      style={{
        WebkitUserDrag: 'none',
        userSelect: 'none',
        ...style,
      }}
    />
  );
}
